<ui-auth-layout>
  <ui-auth-error-banner [error]="error$ | async"></ui-auth-error-banner>

  <!-- Two in-place states, one layout: the challenge is bound to an in-memory
       token, so a reload has to come back to the credentials form. -->
  <ng-container *ngIf="(challenge$ | async) === null">
    <div class="auth-heading">
      <h1 class="auth-heading__title">{{ 'authentication.login' | translate }}</h1>
      <p class="auth-heading__subtitle">{{ 'authentication.login_subtitle' | translate }}</p>
    </div>

    <form
      class="auth-form"
      [formGroup]="loginForm"
      (ngSubmit)="loginAction()"
      (keydown.enter)="onEnterKey($event)"
    >
      <ui-form-field
        [id]="'email'"
        testId="login-email"
        type="email"
        formControlName="email"
        autocomplete="email"
        [label]="'authentication.email' | translate"
        [placeholder]="'authentication.email_placeholder' | translate"
        [errorMessages]="{
          required: 'authentication.required_email' | translate,
          email: 'authentication.invalid_email' | translate
        }"
        [fullWidth]="true"
      ></ui-form-field>

      <ui-form-field
        [id]="'password'"
        testId="login-password"
        formControlName="password"
        autocomplete="current-password"
        [type]="passwordVisible ? 'text' : 'password'"
        [label]="'authentication.password' | translate"
        [placeholder]="'authentication.password_placeholder' | translate"
        [suffixIcon]="passwordVisible ? 'eye-off-cc' : 'eye-cc'"
        [suffixIconClickable]="true"
        [suffixIconPressed]="passwordVisible"
        [suffixIconAriaLabel]="
          (passwordVisible ? 'authentication.hide_password' : 'authentication.show_password') | translate
        "
        (suffixIconClick)="togglePasswordVisibility()"
        [errorMessages]="{
          required: 'authentication.required_password' | translate,
          minlength: 'authentication.password_min_length' | translate
        }"
        [fullWidth]="true"
      ></ui-form-field>

      <div class="auth-form__actions">
        <!-- Only the submit is withheld on MFA_ENROLLMENT_REQUIRED: an
             administrator has to clear it, so a retry repeats the same 403.
             Forgot-password stays -- it is the one thing still worth doing. -->
        <!-- `type` here is the visual variant, not the button's HTML type.
             ui-button renders a <button> with no type attribute, which inside a
             form defaults to submit -- that default is what fires ngSubmit. -->
        <ui-button
          *ngIf="!enrolmentRequired"
          type="primary"
          testId="login-submit"
          [label]="'authentication.login' | translate"
          [fullWidth]="true"
        ></ui-button>

        <a class="auth-link" data-testid="login-forgot-password" [routerLink]="['/forget-password']">
          {{ 'authentication.forgot_password' | translate }}
        </a>
      </div>
    </form>
  </ng-container>

  <app-mfa-challenge *ngIf="challenge$ | async"></app-mfa-challenge>
</ui-auth-layout>
